module.exports = __webpack_public_path__ + "img/Report - Leap Learning French.461f852f.png";